import m from "../../geodata/es2015/southKoreaHigh";
window.am4geodata_southKoreaHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/southKoreaHigh.js
// module id = null
// module chunks = 